module.exports = __webpack_public_path__ + "img/icon-eye.e8b62d0c.png";